module.exports = __webpack_public_path__ + "img/full6-min.0cf1affc.png";